<template>
  <div class="u-px">
    <div ref="mAuthorWrapper" class="c-embed__frame">
      <iframe
        class="c-mauthor-frame"
        name="mAuthorFrame"
        ref="mAuthorFrame"
        :src="mauthorSrc"
        tabindex="0"
        allowfullscreen="allowfullscreen"
        allow="geolocation *; microphone *; camera *; midi *; encrypted-media *"
      ></iframe>
    </div>
    <ContentLoader v-if="!mAuthorLoaded" height="160">
      <rect x="0" y="0" :width="contentWidth" :height="contentHeight"></rect>
    </ContentLoader>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'
import { computed, ref, onBeforeUnmount, onMounted } from '@vue/composition-api'

export default {
  name: 'EmbedExercise',

  components: {
    ContentLoader,
  },

  props: {
    item: Object,
  },

  setup(props, ctx) {
    const mAuthorLoaded = ref(false)
    const mAuthorFrame = ref(null)
    const mAuthorWrapper = ref(null)
    const contentWidth = ref(1026)
    const contentHeight = ref(672)

    const mauthorSrc = computed(() => {
      const tokenString = process.env.VUE_APP_COSS_TOKEN
      return `${process.env.VUE_APP_MAUTHOR_URL}?data=${props.item.embedId}&gateway=${process.env.VUE_APP_API_GATEWAY_URL}&token=${tokenString}`
    })

    onMounted(() => {
      window.addEventListener('message', handleMessage)
      window.addEventListener('resize', screenResiseHandler)
    })

    onBeforeUnmount(async () => {
      window.removeEventListener('message', handleMessage)
      window.removeEventListener('resize', screenResiseHandler)
    })

    function handleMessage(event) {
      const { eventType, eventData } = destructureMessage(event)
      switch (eventType) {
        case 'RESIZE':
          resizeFrame(eventData)
          break
        case 'PLAYER_READY':
          restoreLessonState()
          break
        case 'PLAYER_CLOSE':
          ctx.root.$router.push(
            `/unit/${props.item.unit}?lesson=${props.item.lesson}`,
          )
          break
        default:
          break
      }
    }

    async function restoreLessonState() {
      // We do not store state yet, but player needs that message (event with null to initialize)
      sendMessageToFrame(`LESSON_STATE:${JSON.stringify(null)}`)
    }

    function resizeFrame() {
      mAuthorLoaded.value = true
      mAuthorFrame.value.style.width = `${contentWidth.value}px`
      mAuthorFrame.value.style.height = `${contentHeight.value}px`
      setTimeout(screenResiseHandler, 1)
    }

    function screenResiseHandler() {
      if (mAuthorWrapper.value) {
        const scale = Math.min(
          1,
          mAuthorWrapper.value.offsetWidth / contentWidth.value,
        )
        mAuthorFrame.value.style.transform = `scale(${scale})`
      }
    }

    function destructureMessage(event) {
      const eventTypeMarker =
        event.data.indexOf(':') > -1
          ? event.data.indexOf(':')
          : event.data.length

      const eventType = event.data.substr(0, eventTypeMarker)
      const eventData = event.data.substr(eventTypeMarker + 1)

      return {
        eventType,
        eventData,
      }
    }

    function sendMessageToFrame(message) {
      window.frames['mAuthorFrame'].postMessage(
        message,
        `${process.env.VUE_APP_MAUTHOR_URL}`,
      )
    }

    return {
      mauthorSrc,
      mAuthorFrame,
      mAuthorWrapper,
      mAuthorLoaded,
      contentWidth,
      contentHeight,
    }
  },
}
</script>
